import React, { useMemo } from 'react'

import { useIBRoutesConditions } from '@pages/IntroducingBroker/IntroducingBrokerRoutes'

import { useAccountReadContext } from '@context/AccountContextContext'
import { useSessionEntity } from '@context/EntityContext'

import { TickmillCompaniesEnum } from '@utils/companyName.utils'

import { useAccountSwitch } from '@shared/components/Navigation/ProductSwitch/useAccountSwitch'
import { useProductSwitch } from '@shared/components/Navigation/ProductSwitch/useProductSwitch'
import { useAccountSwitchMenu } from '@shared/components/Navigation/menuSections/useAccountSwitchMenu'
import { useProductSwitchMenu } from '@shared/components/Navigation/menuSections/useProductSwitchMenu'
import { SidebarItem } from '@shared/components/Navigation/v2/Sidebar/SidebarItem'

/**
 * Sidebar Switcher — shows product switch (CFD/ETD) or account switch (Trader/Partner) - it's not for now
 * Placed: bottom of sidebar but above toggle button
 * - UK - we show showProductSwitcher
 * - IB accounts - Trader<>Partner switch check - (WCA-6012, to be implemented)
 */
export const SidebarSwitcher: React.FC = () => {
  const { account } = useAccountReadContext()
  const entity = useSessionEntity()
  const { isIBVisible } = useIBRoutesConditions()
  const handleProductSwitch = useProductSwitch()
  const handleAccountSwitch = useAccountSwitch()
  const productSwitchMenu = useProductSwitchMenu(handleProductSwitch)
  const accountSwitchMenu = useAccountSwitchMenu(handleAccountSwitch)

  const showProductSwitcher = useMemo(() => {
    return (
      entity === TickmillCompaniesEnum.TICKMILL_UK &&
      !!account?.visibilityConfiguration?.showProductSwitcher
    )
  }, [entity, account?.visibilityConfiguration?.showProductSwitcher])

  const showAccountSwitcher = isIBVisible

  if (!showProductSwitcher && !showAccountSwitcher) {
    return null
  }

  return (
    <>
      {showAccountSwitcher && <SidebarItem item={accountSwitchMenu} />}
      {showProductSwitcher && <SidebarItem item={productSwitchMenu} />}
    </>
  )
}
